/* template */
<template><div><Index :pageConfig="(pageConfig)" :info="(info)" v-if="(show)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m34e88138"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m34e88138"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isFirst&isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=page&index=0&isFirst&isPage&lang=js&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m34e88138"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarTitleText":"","backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Index':getComponent(require("../../editor/hxz/index.mpx?isComponent&outputPath=components%2Findex05f76066%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
